export type CredentialDetails =
	| { isAuthenticated: false }
	| {
			isAuthenticated: true
			email: string
			name: string
			initials: string
			picture: string
	  }

export type AuthenticationContext = {
	credentialDetails: CredentialDetails
	logout: () => void
	createImpersonateLink: (impersonationContext: {
		baseUrl: string
		userId: string
		tenantSubDomain: string
	}) => string
}

export type GoogleDecodedIdToken = {
	iss: string // Issuer
	azp: string // Authorized Party
	aud: string // Audience
	sub: string // Subject
	hd: string // Google Workspace domain
	email: string
	email_verified: boolean
	nbf: number // Not valid before timestamp
	name: string // Full name
	picture: string // Url for picture
	given_name: string
	family_name: string
	iat: number // Issued at timestamp
	exp: number // Expiry timestamp
	jti: string // Unique identifier for this token
}

// TODO: WABA: Obsolete now that claims are retrieved separately from the JWT
export type DecodedAccessToken = {
	nameid: string
	name: string
	given_name: string
	unique_name: string
	email: string
	picture: string
	role: string
	nbf: number
	exp: number
	iat: number
	iss: string
	aud: string
}

export const claimKeys = {
	nameIdentifier:
		"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier",
	name: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name",
	givenName:
		"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
	picture: "picture",
	userName:
		"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
	role: "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
	notBefore: "nbf",
	expiresAt: "exp",
	issuedAt: "iat",
	issuer: "iss",
	audience: "aud"
} as const
export type ClaimKey = (typeof claimKeys)[keyof typeof claimKeys]

export type Claim = { type: ClaimKey; value: string }

export type TokenResponse = {
	access_token: string
	expires_in: number
}
